<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      style="margin-top:12vh;"
      width="573px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">超出点位数</div>
      <div class="tip-container">
        <div>该角色内成员数已超出您购买的客莱宝侧边栏点位数，请减少该角色内成员再次保存！</div>
        <div>剩余可用{{num}}个点位</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="dialogVisible=false" style="margin-right:20px">取消</el-button>
        <el-button type="primary"   @click="dialogVisible=false" >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'tipDialog',
  data() {
    return {
      dialogVisible: false,
      num: 0,
    }
  },
  methods: {
    show(num) {
      this.dialogVisible = true;
      this.num = num
    },

  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  color: black;
}
.tip-container {
  font-size: 14px;
  line-height: 30px;
}
/deep/ .el-dialog__body {
  padding: 10px 20px 20px;
  border-top: 1px solid #D7D7D7;
}
</style>